module.exports = __webpack_public_path__ + "static/Photo03-75538f6dda93d5d6c94976049010554e.png";